import { useEffect } from "react";
import Footer from "../components/Footer";
import Header from "../components/Header";
import { useTranslation } from "react-i18next";
import { useConfigContext } from "../providers/ConfigProvider";

const Cookies = () => {
    const { t } = useTranslation();
    const { data } = useConfigContext();

    useEffect(() => {
        // Create and append the script element
        const script = document.createElement('script');
        script.id = 'CookieDeclaration';
        script.src = `https://consent.cookiebot.com/${data?.cookiebot_id}/cd.js`;
        script.type = 'text/javascript';
        script.async = true;
        document.body.appendChild(script);

        // Cleanup on unmount
        return () => {
            document.body.removeChild(script);
        };
    }, []);

    return (
        <div className="container">
            <Header
                backLink={{
                    link: "/",
                    text: "Tilbake til oversikt"
                }}
            />

            <div className="row justify-content-center mt-5 pb-5">
                <div className="col-lg-8">
                    <h1>{t("cookies")}</h1>
                    <div id="CookieDeclaration"></div>
                </div>
            </div>

            <Footer />
        </div>
    )
}

export default Cookies;